module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.initialized) ? _c('div', [(_vm.documentReady) ? _c('div', [_c('h2', [_vm._v("Your file is finished")])]) : (_vm.isWaitingWire) ? _c('div', [_c('h2', [_vm._v("We are wainting for the payment")])]) : (_vm.paymentDone) ? _c('div', [_c('h2', [_vm._v("Your file has to be completed")])]) : (_vm.isInReview) ? _c('div', [_c('h2', [_vm._v("Your file is processing")])]) : (!_vm.hasValues) ? _c('div', [_vm._m(0), _vm._v(" "), _c('h2', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Simplified procedure to appeal after a visa refusal.")]), _vm._v(" "), _c('h3', {
    staticStyle: {
      "text-align": "center",
      "font-size": "1.3em",
      "font-weight": "400"
    }
  }, [_vm._v("Your appeal file in 4 steps")]), _vm._v(" "), _vm._m(1)]) : _c('div', [_c('h2', [_vm._v("Continue your file")])]), _vm._v(" "), (!_vm.displayUserForm) ? _c('div', {
    staticStyle: {
      "margin": "16px 0px"
    }
  }, [(_vm.values && (_vm.values.id_user_prenom || _vm.values.id_user_nom || _vm.values.id_user_mail || _vm.values.id_user_phnum)) ? _c('div', [_c('div', {
    staticClass: "light-frame",
    staticStyle: {
      "display": "flex",
      "justify-content": "space-between"
    }
  }, [_c('div', {
    staticStyle: {
      "padding": "16px 16px"
    }
  }, [_c('div', {
    staticClass: "md-headline"
  }, [_vm._v(_vm._s(_vm.values.id_user_prenom) + " " + _vm._s(_vm.values.id_user_nom))]), _vm._v(" "), _c('div', {
    staticClass: "md-caption"
  }, [_vm._v(_vm._s(_vm.values.id_user_adress_street) + ", " + _vm._s(_vm.values.id_user_adress_city) + ", " + _vm._s(_vm.values.id_user_adress_country))]), _vm._v(" "), _c('div', {
    staticClass: "md-caption"
  }, [_vm._v(_vm._s(_vm.values.id_user_mail))]), _vm._v(" "), _c('div', {
    staticClass: "md-caption"
  }, [_vm._v(_vm._s(_vm.values.id_user_phnum))])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "16px 0px"
    }
  }, [_c('md-button', {
    staticClass: "md-icon-button",
    on: {
      "click": function($event) {
        _vm.displayUserForm = true
      }
    }
  }, [_c('md-icon', [_vm._v("mode_edit")])], 1)], 1)])]) : _vm._e()]) : _c('div', {
    staticClass: "light-frame",
    staticStyle: {
      "padding": "16px",
      "margin": "16px 0px"
    }
  }, [_c('user-form', {
    ref: "userForm",
    attrs: {
      "questions": _vm.questions,
      "values": _vm.values,
      "error-messages": _vm.errorMessages
    }
  }), _vm._v(" "), (_vm.userFormHasError) ? _c('div', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("\n      Complètez le formulaire.\n    ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "centered-child",
    staticStyle: {
      "margin-top": "48px"
    }
  }, [_c('md-button', {
    staticClass: "md-raised md-primary large-button",
    on: {
      "click": function($event) {
        return _vm.onClickValidate()
      }
    }
  }, [_vm._v("Confirm")])], 1)], 1), _vm._v(" "), (_vm.dateLimite) ? _c('div', {
    staticClass: "light-frame date-limit",
    style: ({
      color: _vm.remainingDays > 0 && _vm.remainingDays <= 7 ? 'white' : 'black',
      backgroundColor: _vm.remainingDays > 0 && _vm.remainingDays <= 7 ? 'red' : 'white'
    })
  }, [_c('div', {
    staticStyle: {
      "font-size": "1.1em",
      "text-align": "center",
      "padding": "16px 8px"
    }
  }, [_vm._v("Deadline to send your appeal "), _c('b', [_vm._v(_vm._s(_vm.dateLimiteStr))])]), _vm._v(" "), (_vm.remainingDays > 0) ? _c('div', {
    staticStyle: {
      "font-size": "1.5em",
      "font-weight": "500",
      "padding": "0px 8px 16px 8px"
    }
  }, [_vm._v("Only " + _vm._s(_vm.remainingDaysStr))]) : _vm._e()]) : _vm._e(), _vm._v(" "), _vm._l((_vm.purchases), function(purchase) {
    return _c('div', [(purchase == 'VISA') ? _c('md-card', {
      staticClass: "light-frame"
    }, [_c('md-card-header', [_c('md-card-header-text', [_c('div', {
      staticClass: "md-title"
    }, [_vm._v("Help with your visa application file")]), _vm._v(" "), _c('div', {
      staticClass: "md-subhead"
    }, [_vm._v("Help with your visa application file. 10 minutes questionnaire, cover letter, online procedure, online support.")])]), _vm._v(" "), _c('md-card-media', [_c('img', {
      attrs: {
        "src": "/static/contract.svg"
      }
    })])], 1)], 1) : _vm._e(), _vm._v(" "), (purchase == 'CRRV') ? _c('md-card', {
      staticClass: "light-frame"
    }, [_c('md-card-header', [_c('md-card-header-text', [_c('div', {
      staticClass: "md-title"
    }, [_vm._v(" Appeal to the Appeals Board on Visa Refusals")]), _vm._v(" "), _c('div', {
      staticClass: "md-subhead"
    }, [_vm._v(" appeal to the Appeals Board on Visa Refusals.  10 minutes questionnaire, cover letter, online procedure, online support.")])]), _vm._v(" "), _c('md-card-media', [_c('img', {
      attrs: {
        "src": "/static/contract.svg"
      }
    })])], 1)], 1) : _vm._e(), _vm._v(" "), (purchase == 'TA') ? _c('md-card', {
      staticClass: "light-frame"
    }, [_c('md-card-header', [_c('md-card-header-text', [_c('div', {
      staticClass: "md-title"
    }, [_vm._v("Appeal to the Administrative Court of Nantes")]), _vm._v(" "), _c('div', {
      staticClass: "md-subhead"
    }, [_vm._v("Appeal to the Administrative Court of Nantes.  10 minutes questionnaire, cover letter, online procedure, online support")])]), _vm._v(" "), _c('md-card-media', [_c('img', {
      attrs: {
        "src": "/static/contract.svg"
      }
    })])], 1)], 1) : _vm._e(), _vm._v(" "), (purchase == 'PREMIUM') ? _c('md-card', {
      staticClass: "light-frame"
    }, [_c('md-card-header', [_c('md-card-header-text', [_c('div', {
      staticClass: "md-title"
    }, [_vm._v(" Premium Pack ")]), _vm._v(" "), _c('div', {
      staticClass: "md-subhead"
    }, [_vm._v("You are assisted and defended by a specialised lawyer.")])]), _vm._v(" "), _c('md-card-media', [_c('img', {
      attrs: {
        "src": "/static/lawyer.svg"
      }
    })])], 1)], 1) : _vm._e()], 1)
  }), _vm._v(" "), (_vm.documentReady) ? _c('div', [_c('p', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("\n       Your file has been checked by our lawyers.\n    ")]), _vm._v(" "), (_vm.purchases.includes('CRRV')) ? _c('div', {
    staticClass: "centered-child"
  }, [_vm._m(2), _vm._v(" "), _vm._m(3)]) : (_vm.purchases.includes('TA')) ? _c('div', {
    staticClass: "centered-child"
  }, [_vm._m(4), _vm._v(" "), _vm._m(5)]) : _vm._e()]) : (_vm.paymentDone) ? _c('div', [_c('p', [_vm._v("\n     Your file is almost ready. You need to add the attached documents whiwh will support the contestation. Once donce, yor file will be sent to our experts who will verify everything and send it back to you by email.\n    ")])]) : (_vm.isWaitingWire) ? _c('div', [_c('p', [_vm._v("\n      We are waiting for your payment before preparing all the documents.\n    ")])]) : (_vm.isInReview) ? _c('div', [_c('p', [_vm._v("\n      Your file is being processing by our team. We will send you an email when it will be ready to be sent to the administration.\n    ")])]) : (_vm.hasValues) ? _c('div', [_c('p', [_vm._v("\n     First of all, you can fill your file in order to propose you the best service according to your situation.\n    ")])]) : _vm._e(), _vm._v(" "), (_vm.isWaitingWire) ? _c('div', [_c('p', {
    staticStyle: {
      "color": "white",
      "background-color": "red",
      "text-align": "center",
      "padding": "16px",
      "font-size": "1.2em",
      "font-weight": "500"
    }
  }, [_vm._v("\n     We are wainting for the payment of " + _vm._s(_vm.values.id_virement_amount) + "€ before finishing your file.\n    ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center",
      "padding": "16px 16px 8px 16px",
      "font-size": "1.2em",
      "border": "1px solid #eee"
    }
  }, [_vm._v("\n     If you have a friend who have a payment card like MasterCard, VISA ou AMEX, he/she can pay for you.\n      Send him/her this link:\n      "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "pay-url"
  }, [_vm._v(_vm._s(_vm.payURL))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "8px",
      "display": "flex",
      "flex-wrap": "wrap",
      "justify-content": "center"
    }
  }, [_c('md-button', {
    on: {
      "click": function($event) {
        return _vm.onCopy()
      }
    }
  }, [_vm._v("Copy")]), _vm._v(" "), _c('md-button', {
    on: {
      "click": function($event) {
        return _vm.onEmail()
      }
    }
  }, [_vm._v("Send by email")])], 1)]), _vm._v(" "), (_vm.values.id_virement_type == 'wire') ? _c('div', {
    staticClass: "light-frame visa-frame"
  }, [_c('h3', [_vm._v("Payment by international bank transfer")]), _vm._v(" "), _c('p', [_vm._v("To proceed the pyament you have to make a international bank transfer on GetMyVisaToFrance account")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "padding-left": "16px"
    }
  }, [_c('b', [_vm._v("Amount: " + _vm._s(_vm.values.id_virement_amount) + "€")]), _c('br'), _vm._v(" "), _c('b', [_vm._v("IBAN : DE06100110012626269080")]), _c('br'), _vm._v(" "), _c('b', [_vm._v("BIC/SWIFT : NTSBDEB1XXX")])])]) : _vm._e(), _vm._v(" "), (_vm.values.id_virement_type == 'mandat-express') ? _c('div', {
    staticClass: "light-frame visa-frame"
  }, [_c('h3', [_vm._v("Payment by Express Money Order ")]), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('p', {
    staticStyle: {
      "padding-left": "16px"
    }
  }, [_c('b', [_vm._v("AMount: " + _vm._s(_vm.values.id_virement_amount) + "€")]), _c('br'), _vm._v(" "), _c('b', [_vm._v("Name of the company : OCTAGRAM SAS")]), _c('br'), _vm._v(" "), _c('b', [_vm._v("Adress : 59 rue Chardon Lagache 75016 Paris")])])]) : _vm._e(), _vm._v(" "), (_vm.values.id_virement_type == 'western-union') ? _c('div', {
    staticClass: "light-frame visa-frame"
  }, [_c('h3', [_vm._v("Payment by Western Union")]), _vm._v(" "), _vm._m(7), _vm._v(" "), _c('p', {
    staticStyle: {
      "padding-left": "16px"
    }
  }, [_c('b', [_vm._v("Amount: " + _vm._s(_vm.values.id_virement_amount) + "€")]), _c('br'), _vm._v(" "), _c('b', [_vm._v("First name : Alexandre, René, Georges")]), _c('br'), _vm._v(" "), _c('b', [_vm._v("Last name : GRUX")]), _c('br'), _vm._v(" "), _c('b', [_vm._v("Adress : 59 rue Chardon Lagache 75016 Paris")])])]) : _vm._e(), _vm._v(" "), _vm._m(8)]) : (_vm.documentReady) ? _c('div', [_c('div', {
    staticClass: "centered-child",
    staticStyle: {
      "margin-top": "0px",
      "align-items": "center",
      "flex-direction": "column"
    }
  }, [_c('md-button', {
    staticClass: "md-accent",
    on: {
      "click": function($event) {
        return _vm.onClickView()
      }
    }
  }, [_vm._v("Download the document")])], 1)]) : (!_vm.isInReview) ? _c('div', {
    staticClass: "centered-child",
    staticStyle: {
      "margin-top": "32px"
    }
  }, [(_vm.hasValues) ? _c('div', [_c('md-button', {
    staticClass: "md-raised md-primary large-button",
    on: {
      "click": function($event) {
        return _vm.onClickComplete()
      }
    }
  }, [_vm._v("Complete your file")]), _vm._v(" "), (_vm.purchases && _vm.purchases.length > 0) ? _c('div', [_c('md-button', {
    staticClass: "md-raised md-primary large-button",
    on: {
      "click": function($event) {
        return _vm.onClickConsult()
      }
    }
  }, [_vm._v("Change your answers")])], 1) : _vm._e(), _vm._v(" "), (_vm.hasValueFiles) ? _c('div', [_c('md-button', {
    staticClass: "md-raised md-primary large-button",
    on: {
      "click": function($event) {
        return _vm.onClickRender()
      }
    }
  }, [_vm._v("Finish your appeal")])], 1) : _vm._e()], 1) : _c('div', {
    staticStyle: {
      "display": "flex",
      "width": "100%",
      "align-items": "center",
      "flex-direction": "column"
    }
  }, [_c('div', [_c('md-button', {
    staticClass: "md-raised md-primary large-button",
    on: {
      "click": function($event) {
        return _vm.onClickStart()
      }
    }
  }, [_vm._v("Continue")])], 1)])]) : _vm._e()], 2) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "centered-child",
    staticStyle: {
      "padding-bottom": "16px"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "100%",
      "max-width": "200px"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/justice.svg",
      "width": "100%"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container1234"
  }, [_c('div', {
    staticClass: "item1234"
  }, [_c('span', {
    staticClass: "badge1234"
  }, [_vm._v("1")]), _vm._v(" "), _c('div', {
    staticClass: "right1234"
  }, [_c('span', {
    staticStyle: {
      "font-size": "1.3em"
    }
  }, [_vm._v("Qualification")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "display": "block",
      "margin-top": "4px"
    }
  }, [_vm._v("Thanks to our online questionnaire, you will check if you are still able to appeal and see which appeal procedure you need.")])])]), _vm._v(" "), _c('div', {
    staticClass: "item1234"
  }, [_c('span', {
    staticClass: "badge1234"
  }, [_vm._v("2")]), _vm._v(" "), _c('div', {
    staticClass: "right1234"
  }, [_c('span', {
    staticStyle: {
      "font-size": "1.3em"
    }
  }, [_vm._v("Payment")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "display": "block",
      "margin-top": "4px"
    }
  }, [_vm._v("Choose one service (standard or premium) and make the payment online or by order money.")])])]), _vm._v(" "), _c('div', {
    staticClass: "item1234"
  }, [_c('span', {
    staticClass: "badge1234"
  }, [_vm._v("3")]), _vm._v(" "), _c('div', {
    staticClass: "right1234"
  }, [_c('span', {
    staticStyle: {
      "font-size": "1.3em"
    }
  }, [_vm._v("Creation of the file")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "display": "block",
      "margin-top": "4px"
    }
  }, [_vm._v("You prepare your file by adding all the documents suggested according to your situation.")])])]), _vm._v(" "), _c('div', {
    staticClass: "item1234"
  }, [_c('span', {
    staticClass: "badge1234"
  }, [_vm._v("4")]), _vm._v(" "), _c('div', {
    staticClass: "right1234"
  }, [_c('span', {
    staticStyle: {
      "font-size": "1.3em"
    }
  }, [_vm._v("Processing and mailing")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "display": "block",
      "margin-top": "4px"
    }
  }, [_vm._v("Your file is ready and has been checked by our experts. You just need to print it and send it to the address indicated.")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("\n        You can now "), _c('strong', [_vm._v("download")]), _vm._v("\n        the document, print it in "), _c('strong', [_vm._v("1 copy")]), _vm._v(",  "), _c('strong', [_vm._v("sign")]), _vm._v(" it, add the "), _c('strong', [_vm._v("attached documents")]), _vm._v(" and send it\n        by "), _c('strong', [_vm._v("registered post with acknowledgement of receipt")]), _vm._v(" to this address :\n      ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "display": "inline-block",
      "text-align": "center",
      "border": "1px solid",
      "padding": "16px 32px"
    }
  }, [_vm._v("\n        Commission contre les refus de visa d'entrée en France"), _c('br'), _vm._v("\n        BP 83609"), _c('br'), _vm._v("\n        44036 Nantes Cedex 01"), _c('br'), _vm._v("\n        France"), _c('br')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("\n          You can now "), _c('strong', [_vm._v("download")]), _vm._v("\n         the document, print it in "), _c('strong', [_vm._v("4 copies")]), _vm._v(",  "), _c('strong', [_vm._v("sign")]), _vm._v(" it, add the"), _c('strong', [_vm._v("attached documents")]), _vm._v("  and send it\n          by "), _c('strong', [_vm._v("registered post with acknowledgement of receipt")]), _vm._v(" to this address:\n      ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "display": "inline-block",
      "text-align": "center",
      "border": "1px solid",
      "padding": "16px 32px"
    }
  }, [_vm._v("\n        Tribunal administratif de Nantes, Monsieur et Madame le Greffier"), _c('br'), _vm._v("\n        BP 24111"), _c('br'), _vm._v("\n        44041 Nantes Cedex 1"), _c('br'), _vm._v("\n        France"), _c('br')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("To proceed the payment you have to go "), _c('u', [_vm._v("in a post office")]), _vm._v(" to make an international Express Money Order \n       on the OCTAGRAM SAS account, GetMyVIsaToFrance oprator.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("To proceed the payment you have to go "), _c('u', [_vm._v("in a Western Union agency")]), _vm._v(" to make the transfer\n       to the legal representative of the OCTAGRAM SAS company, GetMyVIsaToFrance oprator.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "color": "white",
      "background-color": "#2196F3",
      "text-align": "center",
      "padding": "16px",
      "font-size": "1.2em",
      "font-weight": "500"
    }
  }, [_vm._v("\n     incase of problem with the payment, please call our account service au :"), _c('br'), _vm._v(" "), _c('a', {
    staticStyle: {
      "color": "white",
      "font-size": "1.4em",
      "line-height": "1.5em"
    },
    attrs: {
      "href": "tel:+33977218845"
    }
  }, [_vm._v("+33 977 218 845")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5bd05cd8","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/screens/Home.vue
// module id = 738
// module chunks = 3